<template>
  <form-group
      :name="name"
      :label="label"
      :required="required"
      :inline="inline"
      :errors="errors"
  >
    <select
        :id="name"
        :value="displayValue"
        class="custom-select form-control"
        :class="{ 'form-control-danger': errors, [className]: className }"
        @input="event => this.$emit('input', event.target.value)"
        :disabled="disabled"
    >
      <option v-if="placeholder" value="">{{ placeholder }}</option>
      <option
          v-for="option in options"
          :value="get(option, valueField)"
          :key="get(option, valueField)"
      >
        {{ get(option, textField) }}
      </option>
    </select>
    <slot/>
  </form-group>
</template>

<script>
import FormGroup from './FormGroup';

export default {
  name: "InputSelect",
  components: {
    FormGroup
  },
  props: {
    name: String,
    value: [String, Number],
    label: String,
    valueField: {
      type: String,
      default: 'value'
    },
    textField: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    required: Boolean,
    options: Array,
    errors: Array,
    className: [String, Array, Object],
    inline: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    displayValue() {
      return this.value || "";
    }
  }
};
</script>